import { Button } from "@9amhealth/shared";
import styled from "@emotion/styled";
import React, { FC, useState } from "react";
import { KnownProgram } from "src/state/ProgramBloc/ProgramBloc";
import Progress from "src/ui/components/Progress/Progress";
import TaskList from "src/ui/components/TaskList/TaskList";
import Translate from "src/ui/components/Translate/Translate";
import {
  onboardingTasksToShow,
  TaskKey
} from "src/state/TaskManagementBloc/TaskManagementBloc";
import { TasksContext } from "src/constants/tasksContext";

const Container = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h5`
  font-weight: 500;
  line-height: 1.5;
  margin: 0;
`;

const Counter = styled.span`
  font-size: 0.875rem;
  font-weight: 500;
`;

const ProgressTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

interface Props {
  onClose: () => void;
}

export const OnboardingTasksWithoutContext: FC<Props> = ({ onClose }) => {
  const { terminalTasks, totalTasks } = React.useContext(TasksContext);

  const allDone = terminalTasks === totalTasks;

  return (
    <Container>
      <ProgressTitleContainer>
        <Title>
          <Translate msg="onboarding.yourChecklist" />
        </Title>
        <Counter>
          {terminalTasks}/{totalTasks}
        </Counter>
      </ProgressTitleContainer>
      <Progress percent={terminalTasks / totalTasks} />

      <nine-spacer s="lg" />
      <TaskList
        showBadges
        filterVisibleTasks={(task) =>
          onboardingTasksToShow.includes(task.slug as TaskKey)
        }
        programs={[KnownProgram.ONBOARDING]}
      />
      <nine-spacer s="xs" />
      <Translate msg="onboarding.taskOrder" />

      <nine-spacer s="lg" />
      {allDone && (
        <Button
          onPress={onClose}
          style={{
            margin: "0 auto"
          }}
        >
          Continue
        </Button>
      )}
    </Container>
  );
};

export const OnboardingTasks: FC<Props> = (props) => {
  const [terminalTasks, setTerminalTasks] = useState(0);
  const [totalTasks, setTotalTasks] = useState(0);

  return (
    <TasksContext.Provider
      value={{ terminalTasks, setTerminalTasks, totalTasks, setTotalTasks }}
    >
      <OnboardingTasksWithoutContext {...props} />
    </TasksContext.Provider>
  );
};
